module.exports = __webpack_public_path__ + "img/31d66c7e7300ce9b82afd52484133641.31d66c7e.png";